import { uuidv4 } from '@/globals/helpers';
import { Component, Element, Prop, h, Host, Event, EventEmitter } from '@stencil/core';

/**
 * The `pn-segment` is built with a native `input[type="radio"]` in the background.
 * Do not listen to events on the `pn-segment`, but on the `pn-segmented-control` instead.
 */
@Component({
  tag: 'pn-segment',
  styleUrl: 'pn-segment.scss',
})
export class PnSegment {
  id: string = `pn-segment-${uuidv4()}`;

  @Element() hostElement: HTMLElement;

  /** The segment label, same as the slot. */
  @Prop() label?: string;
  /** The segment controller name. */
  @Prop() name!: string;
  /** The segment value. */
  @Prop() value!: string;
  /** Set the segment as selected. Used by the `pn-segmented-control`. **Do not use manually**. @hide true */
  @Prop() selected: boolean = false;
  /** A unique HTML id. */
  @Prop() segmentid: string = this.id;
  /** The SVG content of the icon you want. */
  @Prop() icon?: string;
  /** Disable the segment. */
  @Prop() disabled: boolean = false;

  /** This event is used by the `pn-segmented-control` component. Do not use manually. */
  @Event() segmentHover: EventEmitter<MouseEvent>;
  handleHover(mouse: MouseEvent) {
    this.segmentHover.emit(mouse);
  }

  render() {
    return (
      <Host onMouseEnter={(event: MouseEvent) => this.handleHover(event)}>
        <input
          class="pn-segment"
          id={this.segmentid}
          name={this.name}
          checked={this.selected}
          type="radio"
          value={this.value}
          disabled={this.disabled}
        />
        <label htmlFor={this.segmentid} class="pn-segment-label">
          {this.icon && <pn-icon icon={this.icon} color="blue700"></pn-icon>}
          <span class="pn-segment-text">
            {this.label}
            <slot></slot>
          </span>
        </label>
      </Host>
    );
  }
}
